import React, { Dispatch, SetStateAction } from 'react';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import DropdownMenu, { DropdownMenuOption } from '../../../components/DropdownMenu';
import { TicketPriority, ticketPriorityIsValid } from '../../../constants/Types';
import isMobile from '../../../components/IsMobile';
import { BuildingSettingsPriority } from '../../LocationManagement/components/BuildingSettingsModal/data';

interface PrioritySelectorProps {
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
  selectedPriority: TicketPriority | null;
  setSelectedPriority: Dispatch<SetStateAction<TicketPriority | null>>;
}

const PrioritySelector = ({
  expanded, setExpanded, selectedPriority, setSelectedPriority,
}: PrioritySelectorProps) => {
  const isDev: boolean = useSelector((state:
    { devState: { isDev: boolean } }) => state.devState.isDev);
  const slaNames: string[] = useSelector(
    (state: { selectedBuilding: { SlaHours: BuildingSettingsPriority[] } }) => state
      .selectedBuilding.SlaHours?.map((item: BuildingSettingsPriority) => item.Name),
  );

  const getPriorityOption = (priority: TicketPriority | null) => {
    if (!ticketPriorityIsValid(priority)) return null;
    return { name: `P${priority + 1} - ${slaNames[priority]}`, value: priority };
  };

  const options: DropdownMenuOption[] = Object.values(TicketPriority)
    .filter((value: TicketPriority) => Number.isInteger(value))
    .map((value: number) => getPriorityOption(value));

  return isDev && <DropdownMenu
    {...{ expanded, setExpanded, options }}
    selectedOption={getPriorityOption(selectedPriority)}
    setSelectedOption={(option: DropdownMenuOption | null) => setSelectedPriority(option?.value)}
    title='Priority'
    firstOptionTitle='All priorities'
    defaultTitle='All priorities'
    style={styles.dropdownMenu}
  />;
};

const styles = StyleSheet.create({
  dropdownMenu: {
    width: 200,
    marginEnd: isMobile ? 0 : 48,
    alignSelf: isMobile ? undefined : 'center',
    marginTop: isMobile ? 4 : undefined,
    paddingBottom: isMobile ? 12 : undefined,
    zIndex: 2,
  },
});

export default PrioritySelector;
